import React, { useState, useEffect, useMemo } from 'react';
import { object, func, bool } from 'prop-types';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject } from '../../../utils/helpers';
import { isNull } from '../../../utils/validator';
import { getDateToString, getFormatNumber } from '../../../utils/convert';
import TipoElementoValorModal from '../TipoElementoValorModal';


const TipoElementoValorGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      disabled: false,
      idTipoElemento: 0,
      list: []
  });

  const [editMode, setEditMode] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [removingId, setRemovingId] = useState(null);


  const mount = () => {
    setState(prevState => {
      return {...prevState,
        idTipoElemento: props.data.idTipoElemento,
        list: props.data.list
      };
    });
  }
  useEffect(mount, [props.data]);


  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickTipoElementoAdd() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickTipoElementoView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <>
                                  <div onClick={ (event) => handleClickTipoElementoModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  <div onClick={ (event) => handleClickTipoElementoRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Borrar">delete</span>
                                  </div>
                                  </>
                                  )}                                 
                              </div>

  const tableColumns = [
    { Header: 'Valor', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'valor', width: '45%' },
    { Header: 'Desde', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaDesde', width: '25%' },
    { Header: 'Hasta', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaHasta', width: '25%' },
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }
  ]


  //handles
  const handleClickTipoElementoAdd = () => {
    const editItem = {
      id: -Date.now(),
      idTipoElemento: state.idTipoElemento,
      valor: 0,
      fechaDesde: null,
      fechaHasta: null,
      state: 'a'
    };
    setEditItem(editItem);
    setEditMode(true);
  }
  const handleClickTipoElementoView = (id) => {
    const editItem = state.list.find(x => x.id === id);
    setEditItem(editItem);
    setEditMode(false);
  }
  const handleClickTipoElementoModify = (id) => {
    const editItem = state.list.find(x => x.id === id);
    setEditItem(editItem);
    setEditMode(true);
  }
  const handleClickTipoElementoRemove = (id) => {
    setRemovingId(id);
  }

  //funciones
  function confirmRemoveId(id) {
    const row = CloneObject(state.list.find(x => x.id === id));
    row.state = 'r';
    props.onChange(row);
  }
  function updateTipoElemento(row) {
    row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange(row);
  }

  return (
  <>
    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.list}
    />

    {editItem && 
      <TipoElementoValorModal
          disabled={!editMode}
          data={{
            entity: editItem
          }}
          onDismiss={() => {
            setEditItem(null)
          }}
          onConfirm={(row) => {
            updateTipoElemento(row)
            setEditItem(null)
          }}
      />
    }

    {removingId && 
      <MessageModal
          title={"Confirmación"}
          message={"¿Está seguro de borrar el registro?"}
          onDismiss={() => setRemovingId(null)}
          onConfirm={() => {
            confirmRemoveId(removingId)
            setRemovingId(null)
          }}
      />
    }

  </>
  );
}

TipoElementoValorGrid.propTypes = {
  disabled: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

TipoElementoValorGrid.defaultProps = {
  disabled: false
};

export default TipoElementoValorGrid;